import { createContext, useContext, useMemo, useState } from "react";

const ProductOptionsValueContext = createContext();
const ProductOptionsActionsContext = createContext();

export function ProductOptionsContextProvider({ children }) {
    const [productOptions, setProductOptions] = useState([]);

    const productOptionsActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setProductOptions(newValues);
                },
                setValue: setProductOptions
            }
        },
        []
    )

    return (
        <>
            <ProductOptionsActionsContext.Provider value={{ productOptions: productOptionsActions }}>
                <ProductOptionsValueContext.Provider value={{ productOptions }}>
                    {children}
                </ProductOptionsValueContext.Provider>
            </ProductOptionsActionsContext.Provider>
        </>
    );
}

export function useProductOptionsValueContextHook(props) {
    const value = useContext(ProductOptionsValueContext);

    if (value === undefined) {
        throw new Error('useProductOptionsValueContextHook should be used within ProductOptionsValueContext');
    }

    return {
        productOptions: value.productOptions,
    };
}

export function useProductOptionsActionsContextHook(props) {
    const value = useContext(ProductOptionsActionsContext);

    if (value === undefined) {
        throw new Error('useProductOptionsActionsContextHook should be used within ProductOptionsActionsContext');
    }

    return {
        productOptions: {
            onSet: value.productOptions.onSet,
            setValue: value.productOptions.setValue
        },
    };
}